<template>
  <div class="relative">
    <input
      :id="id"
      class="radio-button"
      :value="radioValue"
      type="radio"
      :name="radioName"
      :disabled="disabled"
      :required="required"
      :checked="checked"
      :tabindex="tabIndex"
      :aria-describedby="ariaDescribedByName"
      @change="radioSelection($event.target.value)"
      @blur="$emit('blur')"
    />
    <label :for="id" class="radio-button-label">{{ labelName }}</label>
  </div>
</template>

<script lang="ts">
export default {
  name: 'RadioButton',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    radioValue: {
      type: [String, Number],
      required: true,
    },
    labelName: {
      type: String,
      required: true,
    },
    radioName: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
    },
    checked: {
      type: Boolean,
      required: false,
    },
    tabIndex: {
      type: Number,
      required: false,
    },
    ariaDescribedByName: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    radioSelection(value: String): void {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-button {
  opacity: 0;
  position: absolute;
  &:focus-visible + .radio-button-label {
    border-radius: theme('borderRadius.md');
    outline: 2px dotted theme('colors.primary.DEFAULT');
    outline-offset: 2px;
  }
  &:checked {
    + .radio-button-label {
      &:before {
        background: theme('colors.primary.DEFAULT');
        border: 1px solid theme('colors.grey.clickable');
        box-shadow: inset 0 0 0 4px theme('colors.foreground');
      }
    }
    &:disabled {
      + .radio-button-label {
        &:before {
          background: theme('colors.grey.graphics.subdued');
          border: 1px solid theme('colors.grey.graphics.subdued');
          box-shadow: inset 0 0 0 4px theme('colors.grey.divider.subdued');
        }
      }
    }
  }
  &:disabled {
    + .radio-button-label {
      color: theme('colors.grey.text.subdued');
      cursor: theme('cursor.not-allowed');
      &:before {
        background: theme('colors.grey.divider.subdued');
        border: 1px solid theme('colors.grey.graphics.subdued');
      }
    }
  }
}
.radio-button-label {
  color: theme('colors.grey.body');
  cursor: theme('cursor.pointer');
  padding: 3px 0;
  position: relative;
  &:before {
    content: '';
    background: theme('colors.foreground');
    border: 1px solid theme('colors.grey.clickable');
    border-radius: theme('borderRadius.full');
    display: inline-block;
    height: 1.5rem;
    position: relative;
    margin-right: 0.5rem;
    top: 6px;
    width: 1.5rem;
  }
}
</style>
